/**
 * Branding
 */

// Module dependencies
import 'protons';
import 'atoms/image';

import './erickson-living.svg';
import './erickson-living-knockout.svg';
import './erickson-living-icon.svg';
import './erickson-living-main.svg';
import './erickson-living-knockout-main.svg';

// Module template
import './_branding.twig';

// Module styles
import './_branding.scss';

export const name = 'branding';

export function disable() {}

export function enable() {}

export default enable;
